module.exports = __webpack_public_path__ + "static/media/manager-on.6aa21705.svg";